import {
  AUTH_TOKEN_KEY,
  GET_LIST_MIDTRANS,
  FETCHING_MIDTRANS,
  SUBMITING_MIDTRANS,
  GET_DETAIL_MIDTRANS,
  // DELETE_MIDTRANS,
  MIDTRANS_ERROR,
  MIDTRANS_ROUTE_API
} from '../constants';
import api from '../utils/Api';
import { manipulateErrors, checkAuthorized } from '../utils';
import { logout } from './authAction';

export const FETCH_LIST_REQ = "FETCH_LIST_REQ";
export const FETCH_DETAILS_REQ = "FETCH_DETAILS_REQ";
// export const DELETE_REQ = "DELETE_REQ";

const onErrorRequest = ({ requestType, error, id }) =>{
  if(!checkAuthorized(manipulateErrors(error))) return logout();
  return {
    type: MIDTRANS_ERROR,
    payload: {
      id,
      requestType,
      ...manipulateErrors(error)
    }
  }
}

const onSuccessRequest = (type, payload) =>({
  type,
  payload
})

const onFetchedRequest = (payload) => ({
  type: FETCHING_MIDTRANS,
  payload
})

const onSubmitedRequest = (payload) => ({
  type: SUBMITING_MIDTRANS,
  payload
})


export const getMidtransList = query => {
  return dispatch => {
    dispatch(onFetchedRequest({ requestType: FETCH_LIST_REQ, bool: true }));
    api({
      Authorization:`Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
    }).get(MIDTRANS_ROUTE_API, query)
    .then(res => {
			dispatch(onSuccessRequest(GET_LIST_MIDTRANS, res.data));
      dispatch(onFetchedRequest({ requestType:FETCH_LIST_REQ, bool: false }));
    })
    .catch(err => {
      dispatch(onErrorRequest({ requestType: FETCH_LIST_REQ, error: err }));
      dispatch(onFetchedRequest({ requestType: FETCH_LIST_REQ, bool: false }));
    })
  }
}

export const getMidtransDetail = id => {
  return dispatch => {
    dispatch(onFetchedRequest({ requestType: FETCH_DETAILS_REQ, bool: true }));
    api({
      Authorization:`Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
    }).get(`${MIDTRANS_ROUTE_API}/${id}`)
    .then(res => {
			dispatch(onSuccessRequest(GET_DETAIL_MIDTRANS, res.data));
      dispatch(onFetchedRequest({ requestType: FETCH_DETAILS_REQ, bool: false }));
    })
    .catch(err => {
      dispatch(onErrorRequest({ requestType: FETCH_DETAILS_REQ, error: err, id }));
      dispatch(onFetchedRequest({ requestType: FETCH_DETAILS_REQ, bool: false }));
    })
  }
}